import { Box, DialogTitle, Divider, Drawer, Stack } from "@mui/material";
import { useState } from "react";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import type { Approval } from "../../../api/types/approvalTypes";
import ApprovalActionDialog from "../ApprovalActionDialog";
import ApprovalActions from "../ApprovalActions";
import type { RequestOrigin } from "../ApprovalWidget";
import ReassignApproversDialog from "../ReassignApproversDialog";
import ApprovalDetailsInfoSection from "./ApprovalDetailsInfoSection";
import ApprovalDetailsStepsSection from "./ApprovalDetailsStepsSection";

interface Props {
  approval: Approval;
  requestOrigin?: RequestOrigin;
  showActionChecks?: boolean;
  onApplyAction: (updatedApproval: Approval) => void;
  onClose: () => void;
  hideSecondaryActions?: boolean;
}

interface DialogState {
  openDialog?: "approve" | "reject" | "cancel" | "reassign";
}

const ApprovalDetailsDrawer = ({
  approval,
  requestOrigin,
  showActionChecks,
  onApplyAction,
  onClose,
  hideSecondaryActions,
}: Props) => {
  const [dialogState, setDialogState] = useState<DialogState>({});

  return (
    <>
      <Drawer anchor="right" open onClose={onClose} sx={{ "& .MuiDrawer-paper": { width: "32rem" } }}>
        <DialogTitle>Approval Details</DialogTitle>
        <Box sx={{ position: "absolute", top: 10, right: 48 }}>
          <ApprovalActions
            approval={approval}
            onActionRequest={(action) => setDialogState({ openDialog: action })}
            hideSecondaryActions={hideSecondaryActions}
          />
        </Box>
        <DialogCloseButton onClick={onClose} />
        <Divider />

        <Stack spacing={4} sx={{ py: 2.5, px: 3, height: "100%", overflow: "scroll", flexGrow: 1 }}>
          <ApprovalDetailsInfoSection approval={approval} requestOrigin={requestOrigin} />
          <ApprovalDetailsStepsSection approval={approval} />
        </Stack>
      </Drawer>
      {dialogState.openDialog && dialogState.openDialog !== "reassign" && (
        <ApprovalActionDialog
          action={dialogState.openDialog}
          approval={approval}
          showActionChecks={showActionChecks}
          onClose={() => setDialogState({})}
          onApply={onApplyAction}
        />
      )}
      {dialogState.openDialog && dialogState.openDialog === "reassign" && (
        <ReassignApproversDialog approval={approval} onClose={() => setDialogState({})} onApply={onApplyAction} />
      )}
    </>
  );
};

export default ApprovalDetailsDrawer;
